import React, { useMemo, useRef } from 'react'
import PropTypes from 'prop-types'
import JoditEditor from 'jodit-react'
import { Box, FormHelperText } from '@material-ui/core'
import clsx from 'clsx'

import constants from 'constants/index'
import theme from 'theme'
import useStyles from './styles'

const Editor = ({
  configRest,
  disabled = false,
  error = false,
  helperText,
  onChange,
  value = '',
  ...rest
}) => {
  const editor = useRef(null)
  const classes = useStyles()

  const config = useMemo(
    () => ({
      language: 'pt_br',
      spellcheck: true,
      showXPathInStatusbar: false,
      buttons: constants.jodit.DEFAULT_BUTTONS,
      askBeforePasteHTML: false,
      toolbarAdaptive: false,
      style: {
        ...(!!error && {
          border: `1px solid ${theme.palette.error.main}`,
          color: theme.palette.error.main,
        }),
      },
      height: 300,
      zIndex: 1,
      readonly: disabled,
      ...configRest,
    }),
    [error, configRest, disabled],
  )

  return (
    <Box
      className={clsx(classes.editorBox, {
        [classes.editorDisabled]: disabled,
      })}
    >
      <JoditEditor
        config={config}
        ref={editor}
        onBlur={(value) => onChange(value)}
        value={value}
        {...rest}
      />
      {!!error && (
        <FormHelperText error={!!error}>{<>{helperText}</>}</FormHelperText>
      )}
    </Box>
  )
}

Editor.propTypes = {
  configRest: PropTypes.object,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
}

export default Editor
